module.exports = __webpack_public_path__ + "img/forest.70469235.svg";